import React from 'react'
import { Row } from 'react-bootstrap';

interface TermsAndConditionsProps {
    title: string;
}

export const TermsAndConditions = (props: TermsAndConditionsProps) => {
    const { title } = props;
    return (
        <Row className="p-3 pb-5 g-4 open-up" data-aos="zoom-out">
            <h5 className='mb-3'>{ title }</h5>
            <div className="mb-4">
                <p className='text-muted' style={{ fontSize: '1rem' }}>
                    Welcome to Easysauces Nigeria limited, a leading manufacturer of high-quality cooking sauce in Nigeria.  <br />
                    These Terms and Conditions govern your use of our website www.easysauces.com and our products.
                </p>

                <p className='text-muted' style={{ fontSize: '.9rem' }}>
                
                    <h5 style={{ fontSize: '1rem', fontWeight: 600 }} className='mt-5'>Product Information:</h5>
                    <p>Our tomato sauce products have a shelf life of 12 months from the date of manufacture, provided the container remains unopened and stored in a cool, dry place.</p>

                    <h5 style={{ fontSize: '1rem', fontWeight: 600 }} className='mt-5'>Ordering and Payment:</h5>
                    <ul className='text-muted'>
                        <li>All prices are in Nigerian Naira (NGN). </li>
                        <li>We accept payment through credit/debit cards, bank transfer only.</li>
                    </ul>
                    
                    <h5 style={{ fontSize: '1rem', fontWeight: 600 }} className='mt-5'>Delivery:</h5>
                    <ul className='text-muted'>
                        <li>We deliver our products within Lagos,</li>
                        <li>Delivery times are estimated for 24 - 48hrs and may vary due to unforeseen circumstances.</li>
                    </ul>
                    
                    <h5 style={{ fontSize: '1rem', fontWeight: 600 }} className='mt-5'>Governing Law:</h5>
                    <p>These Terms shall be governed by and construed in accordance with the laws of the Federal Republic of Nigeria.</p>
                    
                    <h5 style={{ fontSize: '1rem', fontWeight: 600 }} className='mt-5'>Changes to Terms:</h5>
                    <p>We reserve the right to modify or update these Terms at any time without prior notice.</p>
                    
                    <h5 style={{ fontSize: '1rem', fontWeight: 600 }} className='mt-5 mb-2'>Contact Us:</h5>
                    <p className='mb-0'>If you have any questions or concerns, please contact us via  <a href='mailto:info@easysauces.com'>info@easysauces.com</a></p>
                    <p>By using our website and/or purchasing our products, you acknowledge that you have read, understood, and agree to be bound by these Terms.</p>
                    
                    <p className='mt-5 mt-0'>Thank you for choosing,</p>
                    <h5 style={{ fontSize: '1rem', fontWeight: 400 }} className='mt-1'>Easysauces Nigeria limited.</h5>
                </p>
            </div>
        </Row>
    )
}
